class OverflowScroller {
  element: HTMLElement;

  lastKnownY: number;

  currentTop: number;

  initialTopOffset: number;

  constructor(element) {
    this.element = element;
    this.lastKnownY = window.scrollY;
    this.currentTop = 0;
    this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top, 10);
    this.attachListeners();
  }

  checkPosition() {
    const bounds = this.element.getBoundingClientRect();
    const maxTop = bounds.top + window.scrollY - this.element.offsetTop + this.initialTopOffset;
    const minTop = this.element.clientHeight - window.innerHeight;

    if (window.scrollY < this.lastKnownY) {
      this.currentTop -= window.scrollY - this.lastKnownY;
    } else {
      this.currentTop += this.lastKnownY - window.scrollY;
    }

    this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTopOffset);
    this.lastKnownY = window.scrollY;
    this.element.style.top = `${this.currentTop}px`;
  }

  attachListeners() {
    window.addEventListener('scroll', () => this.checkPosition());
  }
}

export default (element:HTMLElement) => new OverflowScroller(element);
